<template>
  <div class="referral-jam-layout">
    <header class="border-bottom" v-if="company">
      <b-container fluid v-if="isCampaignsEnabled">
        <b-row>
          <b-col>
            <header-block/>
          </b-col>
        </b-row>
      </b-container>
      <b-container v-else>
        <b-row>
          <b-col>

            <b-navbar class="p-0" toggleable="md" v-if="company">
              <b-navbar-brand class="mr-md-5" :to="{ name: 'Dashboard' }" :title="brandName">
                <img v-if="brandLogo" :src="brandLogo"/>
                <h2 v-else>{{ brandName }}</h2>
              </b-navbar-brand>

              <b-navbar-toggle class="border-0" target="nav_collapse">
                <font-awesome-icon icon="user" size="sm"/>
                <font-awesome-icon icon="caret-down" size="xs"/>
              </b-navbar-toggle>

              <b-collapse is-nav id="nav_collapse">
                <b-navbar-nav class="ml-auto">
                  <template v-for="({ title, key, modal, ...props }, i) in headerLinks">
                    <b-nav-item v-if="modal" link-classes="text-right" v-b-modal="modal" :key="key || i" v-bind="props">{{ title }}</b-nav-item>
                    <b-nav-item v-else link-classes="text-right" :key="key || i" v-bind="props">{{ title }}</b-nav-item>
                  </template>

                  <b-nav-item-dropdown class="d-none d-md-block" right no-caret v-if="navLinks.length">
                    <template #button-content>
                      <font-awesome-icon icon="user"/>
                      <font-awesome-icon icon="caret-down" size="sm"/>
                    </template>
                    <b-dropdown-header v-if="user" class="secondary-color-semi-opaque">{{ user.fullName }}</b-dropdown-header>
                    <b-dropdown-item v-for="({ label, ...props }, i) in navLinks" :key="i"
                      v-bind="props">{{ label }}</b-dropdown-item>
                  </b-nav-item-dropdown>
                  <div class="d-md-none">
                    <hr v-if="headerLinks.length > 0"/>
                    <b-nav-item v-for="({ label, ...props }, i) in navLinks" :key="i"
                      link-classes="text-right" v-bind="props">{{ label }}</b-nav-item>
                  </div>
                </b-navbar-nav>
              </b-collapse>
            </b-navbar>

          </b-col>
        </b-row>
      </b-container>
    </header>

    <b-container class="status-bar" v-if="statuses.length">
      <status-bar v-for="(status, i) in statuses" :key="i" class="m-2" :status="status"/>
    </b-container>

    <slot :companyID="companyID" ref="content"/>

    <b-container tag="footer" v-if="companyID">
      <footer-block/>
    </b-container>
  </div>
</template>

<script>
import HeaderBlock from '@/components/HeaderCampaigns';
import FooterBlock from '@/components/Footer-minimal';
import { getStatusesForRoute } from '@/lib/status';
import { mapRoot } from '@src/mixins/root';
import { StatusBar } from '@src/components/Statuses';

export default {
  name: 'ReferralJamLayout',
  components: {
    StatusBar,
    HeaderBlock,
    FooterBlock,
  },
  computed: {
    ...mapRoot([ 'company', 'user', 'isLoggedIn', 'isRecruiterAdmin', 'isCampaignsEnabled' ]),
    brandLogo() {
      const { siteBranding, branding } = this.company || {};
      const { bigLogo: brandLogo } = { ...siteBranding, ...branding };
      return brandLogo && brandLogo.fileLocation ? brandLogo.fileLocation : null;
    },
    brandName() {
      const { siteBranding, branding } = this.company || {};
      const { name: brandName } = { ...siteBranding, ...branding };
      const { name: fallbackName } = this.company || {};
      return brandName || fallbackName || this.brandName;
    },
    companyID() {
      return this.company ? this.company.id : null;
    },
    headerLinks() {
      let { headerLinks } = this.$route.meta || {};
      try {
        headerLinks = typeof headerLinks === 'function' ? headerLinks.call(this, this.$route) : headerLinks;
      } catch (err) {
        this.$log.error(err);
        headerLinks = null;
      }

      if (Array.isArray(headerLinks)) {
        return headerLinks;
      } else if (typeof headerLinks === 'object') {
        return Object.keys(headerLinks).map(title => ({ title, href: headerLinks[title] }));
      } else {
        return [];
      }
    },
    navLinks() {
      if (this.user) {
        return [
          { label: 'Return to site', href: '/' },
          { label: 'Sign Out', to: { name: 'Logout' } },
        ];
      } else {
        return this.$route.name === 'EventPage' ? [] : [
          { label: 'Sign In', to: { name: 'Login' } },
        ];
      }
    },
    statuses() {
      return getStatusesForRoute(this.$route).filter(status => status && status.type === 'bar');
    },
  },
};
</script>

<style lang="scss">
.referral-jam-layout {
  header {
    .container, > .container-fluid, header > .container, .container-fluid {
      // min-height: 100%;
      position: relative;
      width: 100%;

      margin: 0 auto 0 auto;
      max-width: 1600px;
    }
  }
  .container.status-bar {
    // min-height: 100%;
    position: relative;
    width: 100%;

    margin: 0 auto 0 auto;
    max-width: 1600px;
  }
}
</style>



// WEBPACK FOOTER //
// src/layouts/ReferralJam.vue